import { h } from 'preact'

import ErrorContactInfo from '../error_contact_info'

const PrerenderError = ({ error }) => {
  console.debug(error)
  return (
    <div class='container'>
      <div class='row'>
        <section class='mt-5 mb-5'>
          <h2>Oh no!</h2>
          <p>It seems we've encountered an error loading this page. Please contact us so we can assist you while we work this out.</p>
          <ErrorContactInfo />
        </section>
      </div>
    </div>
  )
}

export default PrerenderError
